module.exports = __webpack_public_path__ + "static/media/swap.9fc5f40f.svg";